import * as localforage from "localforage";
import {LIFE_JOURNEY_CACHE_KEY} from "../views/discover/constants";
import type {LocationEcoregionData, LocationRegionData} from "./types";

export const DERIVED_BIRD_DATA_CACHE_KEY = 'derivedBirdDataCache';
export const DERIVED_BIRD_DATA_CACHE_VERSION = 7;
export const LOCATION_ECO_DATA_CACHE_KEY = 'locationEcoDataCache';
export const LOCATION_ECO_DATA_CACHE_VERSION = 5;
export const LOCATION_REGION_DATA_CACHE_KEY = 'locationRegionDataCache';
export const LOCATION_REGION_DATA_CACHE_VERSION = 1;
export const DASHBOARD_SUMMARY_CACHE_KEY = 'dashboardSummaryCache';
export const DASHBOARD_SUMMARY_CACHE_VERSION = 17;

export type CachedDerivedBirdData = {
    version: number,
    sourceObservationCount: number,
    sourceSignature: string,
    observationsBySpecies: CachedObservationsBySpecies[],
    observationsByLocation: CachedObservationsByLocation[]
}

export type CachedObservationsBySpecies = {
    taxonomicOrder: number,
    commonName: string,
    observationIndexes: number[]
}

export type CachedObservationsByLocation = {
    locationId: string,
    location: string,
    observationIndexes: number[]
}

export type CachedLocationEcoData = {
    version: number,
    ecoDataByLocationId: Record<string, LocationEcoregionData>
}

export type CachedLocationRegionData = {
    version: number,
    regionDataByLocationId: Record<string, LocationRegionData>
}

export type DashboardYearStats = {
    species: number,
    locations: number,
    days: number,
    lifers: number
}

export type DashboardRecentActivity = {
    id: string,
    dateLabel: string,
    location: string,
    locationDetailPath?: string,
    regionLabel?: string,
    species: Array<{
        label: string,
        detailPath?: string
    }>,
    timestamp: number
}

export type DashboardRecentAchievement = {
    id: string,
    setId: string,
    color: string,
    title: string,
    description: string,
    earnedDateLabel: string
}

export type DashboardInProgressAchievement = {
    id: string,
    setId: string,
    color: string,
    title: string,
    description: string,
    progressLabel: string,
    percent: number
}

export type DashboardSummary = {
    version: number,
    sourceSignature: string,
    speciesDetailPathByTaxonomicOrder: Record<string, string>,
    yearStatsByYear: Record<string, DashboardYearStats>,
    recentActivity: DashboardRecentActivity[],
    recentAchievements: DashboardRecentAchievement[],
    inProgressAchievements: DashboardInProgressAchievement[],
    numYears: number
}

export const clearDerivedBirdDataCaches = async () => {
    await Promise.all([
        localforage.removeItem(DERIVED_BIRD_DATA_CACHE_KEY),
        localforage.removeItem(LOCATION_ECO_DATA_CACHE_KEY),
        localforage.removeItem(LOCATION_REGION_DATA_CACHE_KEY),
        localforage.removeItem(DASHBOARD_SUMMARY_CACHE_KEY),
        localforage.removeItem(LIFE_JOURNEY_CACHE_KEY)
    ]);
}
